<template>
    <div class="tw-flex tw-gap-4 tw-py-1">
        <!-- img -->
        <div class="tw-size-[75px] tw-rounded-full tw-bg-gray-300"></div>
        <div class="tw-flex tw-flex-col tw-justify-between tw-grow">
            <!-- category -->
            <span class="tw-bg-gray-300 tw-w-10 tw-h-3 tw-rounded-lg"></span>
            <!-- title -->
            <span class="tw-bg-gray-300 tw-w-full tw-h-3 tw-rounded-lg"></span>
            <span class="tw-bg-gray-300 tw-w-1/2 tw-h-3 tw-rounded-lg"></span>
            <!-- date -->
            <span class="tw-bg-gray-300 tw-w-20 tw-h-3 tw-rounded-lg"></span>
        </div>
    </div>
</template>

<script setup lang="ts"></script>

<style lang="scss"></style>
